<template lang="html">
    <v-form ref="form" >
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs12 v-if="step == 1">
                            <v-form v-model="code_ok">
                                <v-text-field
                                label="Code article"
                                v-model="product_code"
                                required
                                :color="color"
                                :loading="loading"
                                :error="error"
                                :hint="message"
                                :rules="rules.product_code"
                                @input="onCodeInput"
                                >
                                </v-text-field>
                            </v-form>
                        </v-flex>

                        <v-flex xs12 v-if="step==2">
                            <data-table
                                :headers="datatable.headers"
                                :endpoint="datatable.endpoint"
                                storeId="comments"
                                ref="list"
                            >
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-right">
                                    <v-checkbox hide-details v-model="requests_id" @change="setRequest(props.item)" color="accent" :value="props.item.id"></v-checkbox>
                                </td>
                                <td class="text-xs-right">
                                    {{props.item.user.first_name}} {{props.item.user.last_name}}
                                </td>
                                <td class="text-xs-right">
                                    {{moment(props.item.created_at).format('DD/MM/YYYY')}}
                                </td>
                                <td class="text-xs-right">
                                    {{props.item.message}}
                                </td>
                            </template>
                            </data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import DataTable from '../../../components/DataTable.vue'
    import moment from 'moment'
    export default {
        components: { DataTable },
        data(){
            return {
                step: 1,
                title:'Importer des demandes',
                icon: 'import_export',
                isValid: false,
                code_ok: false,
                color: 'primary',
                error: false,
                message: null,
                loading: false,
                product_code:'',
                product_id:null,
                requests: [],
                requests_id: [],
                product_requests_count:0,
                moment,
                rules: {
                    product_code: [
                        (v) => !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire',
                    ]
                },
                datatable: {
                    headers: [
                        { text: 'Demandes', sortable: false, value: 'is_request', align: 'right' },
                        { text: 'Auteur', sortable: true, value: 'user_id', align: 'right' },
                        { text: 'Date', sortable: true, value: 'created_at', align: 'right' },
                        { text: 'Message', sortable: false, align: 'right' }
                    ],
                    endpoint: {
                        base: '/api/requests',
                        filters: 'product_id|=|',
                        embed: 'user'
                    }
                }
            }
        },
        methods: {
            onCodeInput() {

            const isValidLength = !!this.product_code && !isNaN(this.product_code) && this.product_code.length > 5;

            if (!isValidLength) {
                this.error = true;
                this.color = 'error';
                this.message = 'Code de 6 chiffres obligatoire';
                return;
            }

            this.checkCode(this.product_code);
        },
            checkCode(code){
                this.loading = true
                this.axios.get(`/api/products?filters=code|=|${code}&embed=requests.files`)
                .then(response => {
                    if(response.data.length > 0) {
                        this.error   = false
                        this.loading = false
                        this.product_id = response.data[0].id
                        if(response.data[0].requests_count > 0) {
                            this.color   = 'success'
                            this.message = ''
                            this.$eventHub.$emit('set-next-button', true)
                            this.datatable.endpoint.filters = 'product_id|=|'+this.product_id
                            this.product_requests_count = response.data[0].requests_count
                            this.requests_id = this.$_.map(response.data[0].requests,'id')
                            this.requests = response.data[0].requests
                        } else {
                            this.color   = 'error'
                            this.message = 'Le produit '+response.data[0].label+' n\'a pas de demandes'
                        }
                    } else {
                        this.error   = true
                        this.loading = false
                        this.color   = 'error'
                        this.message = 'Ce code n\'existe pas'
                    }
                })
            },
            onClose() {
                this.$eventHub.$emit('close-modal')
            },
            onValidate(){
                if(this.requests.length > 0){
                    this.requests.forEach((r,index) => {
                        let model = r
                        let count = this.product_requests_count
                        delete model.id
                        model.product_id = this.$store.state.single.data.id
                        model.position = count + 1
                        model.user_id = this.$store.state.auth.user.id
                        count ++
                        this.axios.post(`/api/requests`, model)
                        .then(response => {
                            if(this.requests[index + 1] == undefined){
                                this.$eventHub.$emit('reload-list')
                                this.$store.dispatch('updateSingleData', { key:'requests_count', value:count })
                                this.onClose()
                            }
                        })
                    })
                }
            },
            onNextStep(){
                this.step++
                this.$eventHub.$emit('set-valid-button',true)
                this.$eventHub.$emit('set-next-button',false)
            },
            setRequest(item) {
                let index_item = this.requests.findIndex(r => r.id == item.id)

                if(item.request_selected) {
                    if(index_item == -1) {
                        this.requests.push(item)
                    }

                } else {
                    if(index_item > -1) {
                        this.requests.splice(index_item, 1)
                    }
                }
            },
        },
        mounted(){
            this.$eventHub.$emit('set-valid-button',false)
            this.$eventHub.$emit('set-next-button',false)
        }

    }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/views/products/single/ImportRequests.vue